import { render, staticRenderFns } from "./PriceDeviationProdInfo.vue?vue&type=template&id=88641224&"
import script from "./PriceDeviationProdInfo.vue?vue&type=script&lang=js&"
export * from "./PriceDeviationProdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports